import React, { useState, useEffect } from 'react'
import {
	ListboxInput,
	ListboxButton,
	ListboxList,
	ListboxOption,
} from '@reach/listbox'
import '@reach/listbox/styles.css'
import "@reach/dialog/styles.css";
import { Plus } from 'react-feather'
import { graphql, useStaticQuery } from 'gatsby'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import { Client } from '../../apollo/client'
import useProduct from '../../hooks/useProduct'
import {
	AddProductBtn,
	Overlay,
	OverlayContent,
	OverlayHead,
	OverlayTitle,
	ActiveTab,
	CloseBtn,
	AddBtnHolder,
	Add,
	SelectionContainer,
	Popover,
	ModelImageContainer,
	ModelImage,
	PlusAdd,
} from './styles'

const APOLLO_PRODUCT_COMPARISON_QUERY = gql`
	query comparisonQuery($series: String!, $locale: String!) {
		models:productCollection(locale: $locale, where: { brand: "Dolphin", series: $series,  series_exists: true, categories: { slug_not:"spare-parts"} }, order: price_DESC) {
			items {
				seoTitle
				model
				tags
				countryAvailability
				imagesCollection {
					items {
						url
					}
				}
			}
		}
	}
`
const APOLLO_MINERAL_COMPARISON_QUERY = gql`
	query comparisonQuery($series: String!, $locale: String!) {
		models:productCollection(locale: $locale,where: { brand: "Mineral Swim", series: $series,  series_exists: true, categories: { slug_not:"spare-parts"} }) {
			items {
				seoTitle
				model
				tags
				countryAvailability
				imagesCollection {
					items {
						url
					}
				}
			}
		}
	}
`
const APOLLO_OZONE_COMPARISON_QUERY = gql`
	query comparisonQuery($series: String!, $locale: String!) {
		models:productCollection(locale: $locale,where: { brand: "Ozone Swim", series: $series,  series_exists: true, categories: { slug_not:"spare-parts"} }) {
			items {
				seoTitle
				model
				tags
				countryAvailability
				imagesCollection {
					items {
						url
					}
				}
			}
		}
	}
`
const APOLLO_MODELIMAGE_QUERY = gql`
	query featureDetails ($title: String!, $locale: String!) {
		modelImage: productCollection(locale: $locale,where: { seoTitle: $title , categories: { slug_not:"spare-parts"}}) {
		 	items {
				seoTitle
				slug
				countryAvailability
				imagesCollection {
					items {
						url
					}
				}
		 	}
		}
	}
`

const AddProduct = ({ title, active, dolphinTag, getDatas, imageNode, locale }) => {
	const lines = useStaticQuery(graphql`
		query addProductQuery {
			residentialLines: allContentfulProduct(filter: { brand: { eq: "Dolphin" }, tags: {eq: "residential"}, countryAvailability: {eq: "AU"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			commercialLines: allContentfulProduct(filter: { brand: { eq: "Dolphin" }, tags: {eq: "commercial"}, countryAvailability: {eq: "AU"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			mineralswimLines: allContentfulProduct(filter: { brand: { eq: "Mineral Swim" }, countryAvailability: {eq: "AU"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			ozoneswimLines: allContentfulProduct(filter: { brand: { eq: "Ozone Swim" }, countryAvailability: {eq: "AU"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			residentialLinesNz: allContentfulProduct(filter: { brand: { eq: "Dolphin" }, tags: {eq: "residential"}, countryAvailability: {eq: "NZ"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			commercialLinesNz: allContentfulProduct(filter: { brand: { eq: "Dolphin" }, tags: {eq: "commercial"}, countryAvailability: {eq: "NZ"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			mineralswimLinesNz: allContentfulProduct(filter: { brand: { eq: "Mineral Swim" }, countryAvailability: {eq: "NZ"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			ozoneswimLinesNz: allContentfulProduct(filter: { brand: { eq: "Ozone Swim" }, countryAvailability: {eq: "NZ"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			residentialLinesZa: allContentfulProduct(filter: { brand: { eq: "Dolphin" }, tags: {eq: "residential"}, countryAvailability: {eq: "ZA"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
			commercialLinesZa: allContentfulProduct(filter: { brand: { eq: "Dolphin" }, tags: {eq: "commercial"}, countryAvailability: {eq: "ZA"} }) {
				distinct(field: series)
				edges {
					node {
						model
						series
					}
				}
			}
		}
	`)
	const { 
		residentialLines,
		commercialLines,
		mineralswimLines,
		ozoneswimLines,
		residentialLinesNz,
		commercialLinesNz,
		mineralswimLinesNz,
		ozoneswimLinesNz,
		residentialLinesZa,
		commercialLinesZa
	} = lines
	const defaultLocale = 'en-AU'
	const [showDialog, setShowDialog] = useState(false)
	const [value, setValue] = useState('default')
	const [modelValue, setModelValue] = useState('defaultModel')
	const [tabName, setTabName] = useState('')
	const [brand, setBrand] = useState('')
	const [slug, setSlug] = useState('')
	const [modelImage, setModelImage] = useState(undefined)
	const open = () => setShowDialog(true)
	const close = () => setShowDialog(false)
	useEffect(() => {
		if ( active.length > 0 ) {
			const [{ tabName, brand, slug }] = active
			setTabName(tabName)
			setBrand(brand)
			setSlug(slug)
		}
	}, [active])

	useEffect(() => {
		setModelValue('defaultModel')
	}, [value])

	useEffect(() => {
		setValue('default')
		setModelValue('defaultModel')
	}, [active])

	const { loading, error, data } = useQuery(APOLLO_PRODUCT_COMPARISON_QUERY, {
		variables: { series: value, locale: locale },
		client: Client,
	})
	const { loading: mineralLoading, error: mineralError, data: mineralData } = useQuery(APOLLO_MINERAL_COMPARISON_QUERY, {
		variables: { series: value, locale: locale },
		client: Client,
	})
	const { loading: ozoneLoading, error: ozoneError, data: ozoneData } = useQuery(APOLLO_OZONE_COMPARISON_QUERY, {
		variables: { series: value, locale: locale },
		client: Client,
	})
	const { loading: modelLoading, error: modelError, data: modelData } = useQuery(APOLLO_MODELIMAGE_QUERY, {
		variables: { title: modelValue, locale: locale },
		client: Client,
	})
	useEffect(() => {
		if (modelData != undefined && modelData.modelImage.items.length > 0 ) {
			setModelImage(modelData)
		}
	})
	const tag = dolphinTag.length > 0 ? dolphinTag[0].tag : ''
	const { addToTable, dataSummary } = useProduct()

	const prodimage = modelImage != undefined ? (
		imageNode.filter((x) => {
			return x.node.slug === modelImage.modelImage.items[0].slug
		})
	) : undefined

	const productCountryFilter = (items, locale) => {
		if ( items.length > 0 ) {
			return items.filter((x, i) => {
				const localeSplit = locale.split('-')
				const langCode = localeSplit[1]
				const check = x.countryAvailability.indexOf(langCode)
				return check >= 0 ? x : null
			})
		} else {
			return []
		}
	}

	return (
		<>
			<AddProductBtn onClick={() => open()}>
				<Plus color="#fff" />
				Add Product
			</AddProductBtn>
			<Overlay isOpen={showDialog} onDismiss={close}>
				<OverlayContent>
					<OverlayHead>
						<OverlayTitle>
							{title} <CloseBtn onClick={close} />
						</OverlayTitle>
						<ActiveTab>{tabName}</ActiveTab>
					</OverlayHead>

					<SelectionContainer>
						{brand === 'Dolphin' ? (
							<>
								<ListboxInput value={value} onChange={(value) => {
									setValue(value)
								}}>
									<ListboxButton arrow="▼" />
									<Popover>
										<ListboxList>
											<ListboxOption value="default">
												Product Line
											</ListboxOption>
											{
												locale === defaultLocale ? (
													tag != '' ? tag === 'residential' ? 
														residentialLines.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														)) : commercialLines.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														)) : ''
												) : (
													locale === 'en-NZ' ? (
														tag != '' ? tag === 'residential' ? 
														residentialLinesNz.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														)) : commercialLinesNz.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														)) : ''	
													) : (
														tag != '' ? tag === 'residential' ? 
														residentialLinesZa.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														)) : commercialLinesZa.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														)) : ''	
													)
												)
											}
										</ListboxList>
									</Popover>
								</ListboxInput>
								<ListboxInput
									value={modelValue}
									onChange={modelValue => setModelValue(modelValue)}
								>
									<ListboxButton arrow="▼" />
									<Popover>
										<ListboxList>
											<ListboxOption value="defaultModel">Model</ListboxOption>
											{data != undefined
												? productCountryFilter(data.models.items, locale)
														.filter(x => {
															return x.tags.includes(tag)
														})
														.map((x, i) => {
															return (
																<ListboxOption key={i} label={x.seoTitle} value={x.seoTitle}>
																	{x.seoTitle}
																</ListboxOption>
															)
														})
												: ''}
										</ListboxList>
									</Popover>
								</ListboxInput>
							</>
						) : brand === 'Mineral Swim' ? (
								<>
									<ListboxInput value={value} onChange={(value) => {
										setValue(value)
									}}>
										<ListboxButton arrow="▼" />
										<Popover>
											<ListboxList>
												<ListboxOption value="default">
													Product Line
											</ListboxOption>
												{
													locale === defaultLocale ? (
														mineralswimLines.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														))
													) : (
														mineralswimLinesNz.distinct.map((line, i) => (
															<ListboxOption key={i} value={line}>{line}</ListboxOption>
														))
													)
												}
											</ListboxList>
										</Popover>
									</ListboxInput>
									<ListboxInput
										value={modelValue}
										onChange={modelValue => setModelValue(modelValue)}
									>
										<ListboxButton arrow="▼" />
										<Popover>
											<ListboxList>
												<ListboxOption value="defaultModel">Model</ListboxOption>
												{mineralData != undefined
													? productCountryFilter(mineralData.models.items, locale)
														.map(x => {
															return (
																<ListboxOption label={x.seoTitle} value={x.seoTitle}>
																	{x.seoTitle}
																</ListboxOption>
															)
														})
													: ''}
											</ListboxList>
										</Popover>
									</ListboxInput>
								</>
						) : brand === 'Ozone Swim' ? (
									<>
										<ListboxInput value={value} onChange={(value) => {
											setValue(value)
										}}>
											<ListboxButton arrow="▼" />
											<Popover>
												<ListboxList>
													<ListboxOption value="default">
														Product Line
											</ListboxOption>
													{
														locale === defaultLocale ? (
															ozoneswimLines.distinct.map((line, i) => (	
																<ListboxOption key={i} value={line}>{line}</ListboxOption>
															))
														) : (
															ozoneswimLinesNz.distinct.map((line, i) => (	
																<ListboxOption key={i} value={line}>{line}</ListboxOption>
															))
														)
													}
												</ListboxList>
											</Popover>
										</ListboxInput>
										<ListboxInput
											value={modelValue}
											onChange={modelValue => setModelValue(modelValue)}
										>
											<ListboxButton arrow="▼" />
											<Popover>
												<ListboxList>
													<ListboxOption value="defaultModel">Model</ListboxOption>
													{ozoneData != undefined
														? productCountryFilter(ozoneData.models.items, locale)
															.map(x => {
																return (
																	<ListboxOption label={x.seoTitle} value={x.seoTitle}>
																		{x.seoTitle}
																	</ListboxOption>
																)
															})
														: ''}
												</ListboxList>
											</Popover>
										</ListboxInput>
									</>
						) : (
							''
						)}
					</SelectionContainer>
					{
						prodimage !=undefined ? (
							<ModelImageContainer>
								<ModelImage>
									<source srcSet={prodimage != undefined ? prodimage[0].node.images[0].fluid.srcWebp : ''} type="image/webp"></source>
									<source srcSet={prodimage != undefined ? `${prodimage[0].node.images[0].fluid.src.split('?')[0]}?fm=png&fl=png8&fit=pad&w=600&h=400` : ''} ></source>
									<img src={prodimage != undefined ? prodimage[0].node.images[0].fluid.src : ''} alt={prodimage != undefined ? prodimage[0].node.images[0].description : ''}/>
								</ModelImage>
							</ModelImageContainer>
						) : ''
					}
					<AddBtnHolder>
						<Add
							onClick={() => {
								close()
								setValue('default')
								setModelValue('defaultModel')
								setModelImage(undefined)
								addToTable(
									slug,
									tag ? tag : '',
									modelValue,
								)
								getDatas(dataSummary(tag ? tag : slug))
							}}
						>
							<PlusAdd width="16" height="16" color="#fff"/>
							Add to comparison
						</Add>
					</AddBtnHolder>
				</OverlayContent>
			</Overlay>
		</>
	)
}

export default AddProduct
